
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('formDelete') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" @click="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p style="margin-bottom:0">{{ $t('wannaDeleteThisForm') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteForm" title="Upload" >
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import FormApi from "../../../api/server/form";

export default {
    name: "formModal",
    methods: {
        close() {
            this.$parent.isModalVisible = false;
        },
        async deleteForm() {
            await FormApi.delete(this.$parent.formToDeleteId);
            this.close();
            this.$emit("reload");
        }
    }
};
</script>
